import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetTextComponent } from "../Components/WidgetTextComponent";
import { PopupTextComponent } from "../Popups/PopupTextComponent";
import { LanguageString } from "../../../Model/LanguageString";

export class WidgetTextProps {
    public title: LanguageString;
    public content: string;

    constructor() {
        this.title = new LanguageString();
        this.content = "";
    }
}

export class WidgetText extends WidgetBase {
    props: WidgetTextProps;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetTextProps();
    }

    getType(): WidgetTypes {
        return WidgetTypes.Text;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);

            if (this.props.title == null)
                this.props.title = new LanguageString();
            if (this.props.content == null)
                this.props.content = "";
        }
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetTextComponent({
            widget: this,
            title: this.props.title,
            content: this.props.content
        });
        return this.component.render();
    }

    parseContentToHtml(markup: string) {
        var contentElement = document.createElement('div');
        contentElement.innerHTML = markup;
        return contentElement;
    }

    showPopup(): void {
        let popup = new PopupTextComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}